import { useState, useCallback } from 'react'
import { consumirApi } from '../../../../utils/consumoApi'
import { debounce } from 'lodash'

const useClientes = () => {
  const [clientes, setClientes] = useState([]) // Resultados de búsqueda
  const [busquedaCliente, setBusquedaCliente] = useState('') // Texto ingresado para buscar
  const [clientesSeleccionados, setClientesSeleccionados] = useState([]) // Clientes seleccionados
  const [mostrarModalSeleccionarCliente, setMostrarModalSeleccionarCliente] = useState(false)
  const idEmpresa = JSON.parse(localStorage.getItem('empresa'))

  // Crear la función debounced utilizando useCallback
  const realizarConsultaDebounced = useCallback(
    debounce(async (cliente) => {
      if (cliente.trim() === '') {
        setClientes([])
      } else {
        const respuesta = await consumirApi('GET', `maestros/cliente/buscar/${idEmpresa}/${cliente}`)
        setClientes(respuesta.success ? respuesta.data : [])
      }
    }, 300),
    [] // Solo se crea una vez
  )

  // Función para mostrar el modal de selección de cliente
  const seleccionarCliente = (e) => {
    e.preventDefault()
    setMostrarModalSeleccionarCliente(true)
  }

  // Maneja la búsqueda de clientes según el texto ingresado
  const manejarBusquedaCliente = (cliente) => {
    setBusquedaCliente(cliente)
    realizarConsultaDebounced(cliente)
  }

  // Selecciona un cliente del listado de sugerencias y lo agrega al array
  const manejarSeleccionCliente = (data) => {
    // Verifica si el cliente ya está seleccionado
    const existe = clientesSeleccionados.some((cliente) => cliente.id === data.id)
    if (!existe) {
      setClientesSeleccionados((prev) => [...prev, { id: data.id, nombres_cliente: data.nombres_cliente }])
    }
    setMostrarModalSeleccionarCliente(false)
    setBusquedaCliente('')
    setClientes([])
  }

  // Elimina un cliente del array de seleccionados
  const eliminarClienteSeleccionado = (id) => {
    setClientesSeleccionados((prev) => prev.filter((cliente) => cliente.id !== id))
  }

  // Limpia los campos y cierra el modal
  const limpiarCamposClientes = () => {
    setBusquedaCliente('')
    setClientes([])
    setMostrarModalSeleccionarCliente(false)
  }

  return {
    clientes,
    busquedaCliente,
    clientesSeleccionados,
    setClientesSeleccionados,
    mostrarModalSeleccionarCliente,
    seleccionarCliente,
    manejarBusquedaCliente,
    manejarSeleccionCliente,
    eliminarClienteSeleccionado,
    limpiarCamposClientes,
  }
}

export default useClientes
